import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { StrategyApiService } from './strategy.service';
import {
  loadStrategyList,
  loadStrategyListSuccess,
  loadStrategyListFailure,
} from './strategy.actions';

@Injectable()
export class StrategyEffects {
  private actions$ = inject(Actions);
  private strategyService = inject(StrategyApiService);

  loadStrategyList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadStrategyList),
      mergeMap(() =>
        this.strategyService.getStrategyList().pipe(
          map((response: any) => {
            if (response.status === 'Failed') {
              return loadStrategyListFailure({ error: response.message });
            }
            return loadStrategyListSuccess({ data: response.data });
          }),
          catchError((error) => of(loadStrategyListFailure({ error })))
        )
      )
    )
  );
}
